export function SuspendedPage() {
  return (
    <div className="min-h-screen bg-sand text-oud-900 flex items-center justify-center p-6" dir="rtl">
      <div className="max-w-sm text-center space-y-5">
        <div className="w-16 h-16 rounded-full bg-oud-100 text-oud-400 flex items-center justify-center mx-auto">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7" aria-hidden>
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <h1 className="text-2xl font-black">انتهت فترة التجربة</h1>
        <p className="text-oud-600 leading-relaxed">
          فترة التجربة المجانية لهذا المتجر انتهت. تواصل مع الإدارة لتفعيل الاشتراك والاستمرار.
        </p>
        <a
          href="/"
          className="inline-block bg-oud-800 text-sand px-6 py-3 rounded-2xl font-bold hover:bg-oud-900 transition-colors"
        >
          الرجوع للرئيسية
        </a>
      </div>
    </div>
  );
}
